import React from "react";

const JumboLayoutRootContext = React.createContext({});

export default JumboLayoutRootContext;
